import React from "react";
import { Link } from "react-router";
import axios from "axios";
import classNames from "classnames";

import { Tooltip } from "../../components/Tooltip";
import Filter from "../../components/Filter";
import { getDeep } from "./../../functions.js";

export default class competenceprofilesOverview extends React.Component {
    constructor(props) {
        super(props);

        let defaultFilters = {};
        defaultFilters["is_active"] = "1";

        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        this.state = {
            resultRows: [],
            count: 0,
            limit: 0,
            offset: 0,
            filterTrainers: [],
            activeFilters: defaultFilters
        };
    }

    cancelAxiosRequest = () => {
        this.cancelSource.cancel();

        this.setState({
            resultRows: false,
            count: 0,
            limit: 0,
            offset: 0
        });
    };

    handleFilter = (name, value) => {
        let activeFilters = this.state.activeFilters;
        activeFilters[name] = value;

        this.setState({
            activeFilters,
            offset: 0
        });
        this.getResults(this.state.offset);
    };

    getResults = (offset) => {
        this.cancelAxiosRequest();
        this.cancelToken = axios.CancelToken;
        this.cancelSource = this.cancelToken.source();

        axios
            .get("/v1/competenceprofiles/", {
                params: {
                    offset: offset,
                    ...this.state.activeFilters
                },
                cancelToken: this.cancelSource.token
            })
            .then((response) => {
                this.setState({
                    resultRows: response.data.results,
                    count: response.data.count,
                    limit: response.data.limit,
                    offset: response.data.offset
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    toggleItem = (e, itemID, itemName, currentStatus) => {
        let question = "Weet je zeker dat je dit competentieprofiel wilt activeren?";
        let description = `Het competentieprofiel '${itemName}' is succesvol geactiveerd`;

        if (currentStatus) {
            // Current status is true, so we toggle to false
            question = "Weet je zeker dat je dit competentieprofiel wilt deactiveren?";
            description = `Het competentieprofiel '${itemName}' is succesvol gedeactiveerd`;
        }

        if (confirm(question)) {
            axios
                .patch("/v1/competenceprofiles/" + itemID + "/", {
                    is_active: !currentStatus
                })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${itemID}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    duplicateItem = (e, itemID, itemName) => {
        e.stopPropagation();

        let question = "Weet je zeker dat je dit competentieprofiel wilt dupliceren?";
        let description = `Het competentieprofiel '${itemName}' is succesvol gedupliceerd`;

        if (confirm(question)) {
            axios({
                method: "copy",
                url: `/v1/competenceprofiles/${itemID}/`
            })
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${response.data.uuid}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    togglePreChecks = (e, itemID, itemName, currentStatus) => {
        let question = "Weet je zeker dat je pre-checks wilt inschakelen voor dit competentieprofiel?";
        let description = `Het competentieprofiel '${itemName}' heeft pre-checks succesvol ingeschakeld`;

        if (currentStatus) {
            question = "Weet je zeker dat je pre-checks wilt uitschakelen voor dit competentieprofiel?";
            description = `Het competentieprofiel '${itemName}' heeft pre-checks succesvol uitgeschakeld`;
        }

        if (confirm(question)) {
            axios
                .patch("/v1/competenceprofiles/" + itemID + "/", {
                    pre_checks: !currentStatus
                })
                .then(() => {
                    this.props.addGlobalMessage({
                        title: description,
                        link: `/competenceprofiles/edit/${itemID}`
                    });
                    this.getResults(0);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    componentDidMount() {
        this.getResults(0);

        // Get trainers for the filter
        return axios
            .get("/v1/trainers/?fields=uuid,name&pagination=false")
            .then((response) => {
                let filterTrainers = [
                    ...response.data.map((item) => {
                        return {
                            value: item.uuid,
                            name: item.name
                        };
                    })
                ];

                this.setState({
                    filterTrainers
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let tableRows = [];

        if (this.state.resultRows !== false) {
            let resultRows = this.state.resultRows;

            if (resultRows.length == 0) {
                tableRows.push(
                    <tr key="0">
                        <td colSpan="10">Met deze filters konden geen resultaten worden gevonden</td>
                    </tr>
                );
            }
            resultRows.forEach((result) => {
                tableRows.push(
                    <tr
                        key={result.uuid}
                        onClick={() => {
                            this.props.router.push("/competenceprofiles/edit/" + result.uuid);
                        }}
                        className={classNames({ inactive: !result.is_active })}
                    >
                        <td>{result.name}</td>
                        <td>
                            <i
                                style={{ marginLeft: "22px" }}
                                className={`fa fa-toggle-${result.pre_checks ? "on" : "off"}`}
                                title={result.pre_checks ? "Deactiveren" : "Activeren"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.togglePreChecks(e, result.uuid, result.name, result.pre_checks);
                                }}
                            ></i>
                        </td>
                        <td>{result.is_standard ? "Ja" : "Nee"}</td>
                        <td>
                            <i
                                className={`fa fa-toggle-${result.is_active ? "on" : "off"}`}
                                title={result.is_active ? "Deactiveren" : "Activeren"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.toggleItem(e, result.uuid, result.name, result.is_active);
                                }}
                            ></i>
                        </td>
                        <td>
                            <i
                                className="fa fa-copy"
                                title="Dupliceren"
                                onClick={(e) => {
                                    this.duplicateItem(e, result.uuid, result.name);
                                }}
                            ></i>
                        </td>
                    </tr>
                );
            });
        } else {
            tableRows.push(
                <tr key="1">
                    <td colSpan="10">Competentieprofielen ophalen...</td>
                </tr>
            );
        }

        return (
            <div>
                <div className="section-top">
                    <h1>Competentieprofielen</h1>

                    <div className="section-buttons">
                        {getDeep(this.props.permissions, "competenceprofile", "create") ? (
                            <Link to="/competenceprofiles/new" className="btn btn-primary">
                                Competentieprofiel toevoegen
                            </Link>
                        ) : (
                            false
                        )}
                    </div>
                </div>

                <div className="row">
                    <div className="col-3 filters">
                        <Filter
                            title="Opleider"
                            type="dropdown"
                            filterName="trainer"
                            filters={this.state.filterTrainers}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                        <Filter
                            title="Evaluatie"
                            type="list"
                            filterName="pre_checks"
                            filters={[
                                { value: "", name: "Alles" },
                                { value: "1", name: "Ja" },
                                { value: "0", name: "Nee" }
                            ]}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                        <Filter
                            title="Status"
                            type="list"
                            filterName="is_active"
                            filters={[
                                { value: "", name: "Alles" },
                                { value: "1", name: "Actief" },
                                { value: "0", name: "Inactief" }
                            ]}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                        <Filter
                            title="Standaard"
                            type="list"
                            filterName="is_standard"
                            filters={[
                                { value: "", name: "Alles" },
                                { value: "1", name: "Ja" },
                                { value: "0", name: "Nee" }
                            ]}
                            handleFilter={(name, value) => this.handleFilter(name, value)}
                            activeFilters={this.state.activeFilters}
                        />
                    </div>
                    <div className="col-9">
                        <div className="filter-text-wrapper">
                            <Filter
                                title="Zoeken"
                                type="text"
                                filterName="search"
                                filters={[]}
                                handleFilter={(name, value) => this.handleFilter(name, value)}
                                activeFilters={this.state.activeFilters}
                            />
                            <i className="fa fa-search" />
                        </div>

                        <table className="table table-hover table-clickable">
                            <thead>
                                <tr>
                                    <th>Titel</th>
                                    <th style={{ display: "flex", alignItems: "center", borderBottom: "none" }}>
                                        <span>Evaluatie</span>
                                        <Tooltip
                                            identifier="evaluation-tooltip"
                                            tooltip={
                                                <p className="paragraph">
                                                    Als dit is geactiveerd betekent het dat dit competentie profiel een vernieuwde versie is van een eerder profiel. Als
                                                    een cursist wordt aangemeld voor deze cursus zal de opleider in het aanmeld scherm op de hoogte worden gesteld van
                                                    eerdere aangetroffen e-learning. Op basis hiervan kan hij vervolgens kiezen de cursist alsnog op de eerdere versie van
                                                    het profiel aan te melden.
                                                </p>
                                            }
                                        />
                                    </th>
                                    <th>Standaard</th>
                                    <th>Actief</th>
                                </tr>
                            </thead>
                            <tbody>{tableRows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
